/**
 * Recursively converts object keys from PascalCase to camelCase.
 * Used to normalize .NET API responses that use PascalCase JSON serialization.
 */

const toCamelCase = (str: string): string =>
  str.charAt(0).toLowerCase() + str.slice(1)

export const normalizeToCamelCase = <T>(value: unknown): T => {
  if (Array.isArray(value)) {
    return value.map((item) => normalizeToCamelCase(item)) as T
  }

  if (value !== null && typeof value === 'object' && !(value instanceof Date)) {
    const result: Record<string, unknown> = {}
    for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
      result[toCamelCase(key)] = normalizeToCamelCase(val)
    }
    return result as T
  }

  return value as T
}
